import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { DateRangePicker, LocalizationProvider } from '@material-ui/pickers';
import MomentUtils from '@material-ui/pickers/adapter/moment';
import { Box } from '@material-ui/core/';

import { getPath } from '../../utils/getPath';
import { useStores } from '../../hooks/use-stores';

const Filter = observer(() => {
    const { ProfileOrderStore: store } = useStores();
    const { onUpdateFilter, onUpdateSearch, onUpdateRange, ordersStatus, selectValue } = store || {};
    const [selectedPeriod, setSelectedPeriod] = useState([null, null]);

    useEffect(() => {
        setSelectedPeriod([null, null]);
    }, [ordersStatus]);

    const handleDateChange = date => {
        setSelectedPeriod(date);
        onUpdateRange(date);
    };

    return (
        <div className="filter-sort mb-30">
            <label className="filter-sort__sort-label">Сортировать&nbsp;по:</label>

            <div className="filter-sort__wrap-sort-search">
                <div className="filter-sort__sort">
                    <select className="filter-sort__select" value={selectValue} onChange={onUpdateFilter}>
                        <option value="dateDecrease">Дата по убыванию</option>
                        <option value="dateIncrease">Дата по возрастанию</option>
                        <option value="priceDecrease">Цена по убыванию</option>
                        <option value="priceIncrease">Цена по возрастанию</option>
                    </select>
                </div>
                <LocalizationProvider dateAdapter={MomentUtils} locale="ru">
                    <DateRangePicker
                        cancelText="Отменить"
                        toolbarTitle="Выбрать диапазон дат"
                        startText="От"
                        endText="До"
                        value={selectedPeriod}
                        onChange={date => handleDateChange(date)}
                        renderInput={(startProps, endProps) => (
                            <Box width={285} display="flex" position="relative">
                                <input
                                    className="legal-form__input period-input__input period-input__input_orders"
                                    ref={startProps.inputRef}
                                    {...startProps.inputProps}
                                    placeholder="Период от"
                                />
                                <input
                                    className="legal-form__input period-input__input period-input__input_orders"
                                    ref={endProps.inputRef}
                                    {...endProps.inputProps}
                                    placeholder="Период до"
                                />
                                <div className="period-input__calendar-btn">
                                    <img src={getPath('public/img/calendar-month.svg')} alt="" />
                                </div>
                            </Box>
                        )}
                        changeView=""
                    />
                </LocalizationProvider>

                <form className="filter-sort__search">
                    <input onChange={onUpdateSearch} className="filter-sort__input" placeholder="Введите номер заказа" type="text" />
                    <i className="filter-sort__icon-search">
                        <svg width="20" height="25" xmlns="http://www.w3.org/2000/svg" id="search" viewBox="0 0 18 18" fill="#cc0514">
                            <path d="M17 15.91L12.88 11.79C14.0541 10.3592 14.633 8.53155 14.4968 6.68565C14.3605 4.83974 13.5196 3.11693 12.1481 1.87396C10.7766 0.630987 8.97964 -0.0369261 7.12927 0.00852395C5.2789 0.053974 3.51688 0.809306 2.20808 2.11811C0.899271 3.42691 0.14394 5.18894 0.0984898 7.03931C0.0530397 8.88968 0.720952 10.6867 1.96392 12.0581C3.20689 13.4296 4.9297 14.2706 6.77561 14.4068C8.62152 14.543 10.4491 13.9641 11.88 12.79L16 16.92C16.1361 17.0335 16.3097 17.092 16.4867 17.084C16.6638 17.076 16.8314 17.0021 16.9567 16.8768C17.0821 16.7515 17.156 16.5838 17.164 16.4068C17.172 16.2297 17.1135 16.0561 17 15.92V15.91ZM7.28998 13C6.1468 13 5.0293 12.661 4.07878 12.0259C3.12827 11.3908 2.38743 10.4881 1.94995 9.43192C1.51248 8.37577 1.39802 7.2136 1.62104 6.09239C1.84406 4.97118 2.39455 3.94128 3.2029 3.13294C4.01125 2.32459 5.04115 1.7741 6.16236 1.55107C7.28357 1.32805 8.44573 1.44251 9.50189 1.87999C10.558 2.31746 11.4608 3.0583 12.0959 4.00882C12.731 4.95933 13.07 6.07684 13.07 7.22001C13.0673 8.75215 12.4575 10.2208 11.3741 11.3042C10.2907 12.3876 8.82212 12.9974 7.28998 13V13Z" />
                        </svg>
                    </i>
                </form>
            </div>
        </div>
    );
});

export default Filter;
